import * as HELPER from "../../../src/config/helper";
import { useLanguage } from "../../../src/context/LanguageContext";

const PremiumRemittance = (props: any) => {
  const {revenue,isLeadFromAgency} = props
  const { translations } = useLanguage();

  return (
    <>
      {/* Premium Remittance Card */}
      <div className="remittance-card">
        <div className="remittance-header">
          <h2>{translations.Remittance?.["PREMIUM_REMITTANCE"] || translations.commonMsg?.loading}</h2>
        </div>
        <div className="remittance-grid">
          <div className="remittance-item">
            <p className="remittance-value">{`${HELPER.addCurrencyFormatting(Number(revenue?.total_premium || 0).toFixed(2))}`}</p>
            <p className="remittance-label">{translations.Remittance?.["TOTAL_PREMIUM"] || translations.commonMsg?.loading}</p>
          </div>
          {/* <div className="remittance-item">
            <p className="remittance-value">{`${HELPER.addCurrencyFormatting(Number(100).toFixed(2))}`}</p>
            <p className="remittance-label">{translations.Remittance?.["PREMIUM_COLLECTED"] || translations.commonMsg?.loading}</p>
          </div> */}
          <div className="remittance-item">
            <p className="remittance-value">{`${HELPER.addCurrencyFormatting(Number(revenue?.paid_to_oto || 0).toFixed(2))}`}</p>
            <p className="remittance-label">{translations.Remittance?.["TO_OTO"] || translations.commonMsg?.loading}</p>
          </div>
          <div className="remittance-item">
            <p className="remittance-value">{`${HELPER.addCurrencyFormatting(Number(revenue?.paid_to_insurer || 0).toFixed(2))}`}</p>
            <p className="remittance-label">{translations.Remittance?.["TO_INSURER"] || translations.commonMsg?.loading}</p>
          </div>
          {
            isLeadFromAgency && 
            <div className="remittance-item">
              <p className="remittance-value">{`${HELPER.addCurrencyFormatting(Number(revenue?.agency_remmitted_amount || 0).toFixed(2))}`}</p>
              <p className="remittance-label">{translations.Remittance?.["TO_AGENCY"] || translations.commonMsg?.loading}</p>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default PremiumRemittance;
